import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const APIService = {
  get,
  post,
  put,
  del,
};

export const HTTP = axios.create({
  baseURL:`${import.meta.env.VITE_API_URL}`,
  headers: {
    "Content-type": "application/json",
  },
});

HTTP.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

HTTP.interceptors.response.use(
  function (response) {
    toast("Successfully Get Response", {
      position: toast.POSITION.TOP_CENTER,
    });
    return response;
  },
  function (error) {
    if (error.response.status) {
      switch (error.response.status) {
        case 400:
          toast("InvalidRequestError", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        case 500:
          toast("Internal Server Error ", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          break;
        case 404:
          toast("Not Found ", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          break;
        case 401:
          toast("the client request has not been completed ", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          break;
        case 403:
          toast("403 Forbidden", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
        case 502:
          toast("Bad Gateway Error ", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          break;
        case 422:
          toast("Unprocessable Entity ", {
            position: toast.POSITION.BOTTOM_CENTER,
          });
          break;
        default:
          break;
      }
    }
    return Promise.reject(error.response.data);
  }
);

// No need of this

// GET method
function get(path, data) {
  return HTTP.get(path, data);
}

// POST method
function post(path, data) {
  return HTTP.post(path, data);
}

// PUT method
function put(path, data) {
  return HTTP.put(path, data);
}

// DELETE method
function del(path, data) {
  return HTTP.delete(path, data);
}
